import base64Encode from '../../../../../utils/base64-encode';

const getAssetsToCreate = (initialPages, currentPages) => {
  const initialPageSources = new Set(initialPages.map((page) => page.source));
  return currentPages
    .filter((page) => !initialPageSources.has(page.source))
    .map((page) => ({ source: page.source, content: base64Encode(page.html) }));
};

export default getAssetsToCreate;
